/* Login com e-mail e senha na API ZNIT: abre, confere e encerra a sessão (token no navegador). */

import { api } from './api';
import { CFG, salvarCfg } from './config';
import type { EmpresaLiberada } from '../tipos/api';

interface RespostaLogin {
  token: string;
  expira_em: string;
  usuario: NonNullable<typeof CFG.usuario>;
  empresas: EmpresaLiberada[];
}

export async function entrarComSenha(email: string, senha: string): Promise<void> {
  const r = await api<RespostaLogin>('POST', '/login', { body: { email, senha }, publica: true });
  CFG.modo = 'api';
  CFG.token = r.token;
  CFG.usuario = r.usuario;
  if (!r.empresas.some((e) => e.cnpj === CFG.cnpj)) CFG.cnpj = '';
  salvarCfg();
}

export function limparSessao(): void {
  CFG.token = '';
  CFG.usuario = null;
  salvarCfg();
}

/** Reabre a plataforma sem novo login enquanto a sessão salva for válida. */
export async function sessaoValida(): Promise<boolean> {
  if (!CFG.token) return false;
  try {
    const r = await api<{ usuario: RespostaLogin['usuario'] }>('GET', '/sessao');
    CFG.usuario = r.usuario;
    salvarCfg();
    return true;
  } catch {
    limparSessao();
    return false;
  }
}

export async function sair(): Promise<void> {
  if (CFG.token) {
    try {
      await api('POST', '/logout');
    } catch {
      /* sem rede: a sessão expira sozinha no backend */
    }
  }
  limparSessao();
}

/** Tema da conta: escuro só para quem escolheu (preferência salva no backend). */
export function aplicarTema(): void {
  const escuro = CFG.modo === 'api' && Boolean(CFG.token) && CFG.usuario?.preferencias?.tema === 'escuro';
  if (escuro) document.documentElement.dataset.theme = 'dark';
  else delete document.documentElement.dataset.theme;
}

export async function definirTema(tema: 'claro' | 'escuro'): Promise<void> {
  const preferencias = await api<NonNullable<NonNullable<typeof CFG.usuario>['preferencias']>>('PUT', '/preferencias', { body: { tema } });
  if (CFG.usuario) CFG.usuario.preferencias = preferencias;
  salvarCfg();
  aplicarTema();
}

export async function trocarSenha(senhaAtual: string, novaSenha: string): Promise<void> {
  await api('POST', '/senha', { body: { senha_atual: senhaAtual, nova_senha: novaSenha } });
}
